import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import actions from './actions'
import modules from './modules'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  h: 0,
  m: 0,
  s: 0,
  sub_isInvitee: true,
  inviteeCount: 0,
  cart: {},
  status: true,
  dutyRangeStatus: true,
  calChange: {},
  signData: {},
  tagData: {},
  calChangeForProblem: {}, // 值班详情数据
  workIng: [],       // 值班中的数据
  dutyArrangeForProblem: [],    // 待值班的数据
  dutyNormalForProblem: [], // 正常签到的数据
  dutyUnNormalForProblem: [], // 异常签到的数据
  signDataForProblem: {}, // 值班签到所有标记日期
  signInSymbol: 0, // 点击签到成功之后刷新日历和列表信号,
  unKnowWorkStatus: [], // 未知状态的数据
  scrollerHeight: 0, // 页面滚动的高度
  router: {}, // 页面路由跳转前存储的内容
  highLightInfo: {},
  isOrNotRelated: [], // 是否已经关联
  detailArr: [],
  modalShow: false,
  interfaceData: {},
  vmReturnToCheck: [],
  netReturnToCheck: [],
  slbReturnToCheck: [],
  addressReturnToCheck: [],
  // intensiveSLBReturnToCheck: [],
  // intensiveAddressReturnToCheck: [],
  intensiveWebsiteAccountReturnToCheck: [],
  pmReturnToCheck: [],
  oracleReturnToCheck: [],
  vmChangeReturnToCheck: [],
  pmDelReturnToCheck: [],
  resourceShareZoneStatus: new Map(), // 资源共享区录入虚拟机名称修改后状态
  publicServiceZoneStatus: new Map(), // 公共服务区录入虚拟机名称修改后状态
  operationResourceList: {},  // 运营审核的时候记录资源信息
  subTableSelectedItemList: [], // 资源目录关联数据表所选择数据项
  dataReturn: {}, // 弹窗关闭返回的数据
  desArr: [],
  allSelectArr: [], // 可编辑数据表页面初始化已勾选的数据项
  deliverSubData: { // 资源信息修改草稿信息传参
    propRegistrationData: {},
    infomationItemsTemp: []
  },
  deliverData: {},
  refresh: false,
  eventTabName: '',
  eventPage: {
    pageNum: 1,
    pageSize: 10
  },
  backFillList: {
    total: 0,
    list: []
  },
  headerRefresh: false,
  headerUserInfo: {},
  fullScreen: false
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  modules,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js